import { Turbo } from "@hotwired/turbo-rails";

function elementHasContainer(el) {
  return el.closest("[data-turbo-scroll-container]") !== null;
}
function isElementInViewport(el) {
  const container = el.closest("[data-turbo-scroll-container]");

  const elRect = el.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  return (
    elRect.top >= containerRect.top &&
    elRect.left >= containerRect.left &&
    elRect.bottom <= containerRect.bottom &&
    elRect.right <= containerRect.right
  );
}

Turbo.StreamActions.scroll_to = function () {
  const target = this.targetElements[0];

  if (
    document.visibilityState !== "visible" ||
    !target ||
    !elementHasContainer(target) ||
    isElementInViewport(target)
  ) {
    return;
  }

  target.scrollIntoView({ behavior: "smooth", block: "end" });
};

Turbo.StreamActions.add_class = function () {
  const classNames = this.getAttribute("class").split(" ");
  this.targetElements.forEach((target) => {
    classNames.forEach((className) => {
      target.classList.add(className);
    });
  });
};

Turbo.StreamActions.remove_class = function () {
  const className = this.getAttribute("class");
  this.targetElements.forEach((target) => {
    target.classList.remove(className);
  });
};

Turbo.StreamActions.check_checkbox = function () {
  this.targetElements.forEach((target) => {
    target.checked = true;
  });
};

// From https://blog.corsego.com/custom-turbo-stream-actions
// <turbo-stream action="redirect" target="/projects"><template></template></turbo-stream>
// turbo_stream.action(:redirect, projects_path)
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

Turbo.StreamActions.insert_after_first = function () {
  this.removeDuplicateTargetChildren();
  this.targetElements.forEach((e) => e.insertBefore(this.templateContent, e.firstChild.nextSibling));
};

function insertInOrder(reverse = false) {
  this.removeDuplicateTargetChildren();
  this.targetElements.forEach((target) => {
    const newElement = this.templateContent.firstElementChild;
    const newOrder = parseInt(newElement.dataset.order) || 0;

    // Find the correct position to insert based on order
    let insert = null;
    for (const child of target.children) {
      const childOrder = parseInt(child.dataset.order) || 0;

      if (reverse) {
        // For descending order: find first child with order < newOrder
        if (childOrder < newOrder) {
          insert = child;
          break;
        }
      } else {
        // For ascending order: find first child with order > newOrder
        if (childOrder > newOrder) {
          insert = child;
          break;
        }
      }
    }

    // Insert before the found element, or append if no element found
    if (insert) {
      target.insertBefore(newElement, insert);
    } else {
      target.appendChild(newElement);
    }
  });
}

Turbo.StreamActions.insert_in_asc_order = function () {
  insertInOrder.call(this);
};

Turbo.StreamActions.insert_in_desc_order = function () {
  insertInOrder.call(this, true);
};
